module.exports = __webpack_public_path__ + "img/ring_g_o_1_null@3x.2e3c05be.png";